import { types } from '../actions/SlideViewerActions';

export default function(state = {}, action) {

    switch (action.type) {
        case types.DRAG_INDEX:
            return Object.assign({}, state, {dragIndex: action.index});

        case types.DROP_INDEX:
            return Object.assign({}, state, {dropIndex: action.index});

        case types.NEEDS_REFRESH:
            return Object.assign({}, state, {needsRefresh: action.value});

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/SlideViewerReducer.js
 **/